interface RoomEntryModule {
  sharedSync?: () => {
    setPresent(present: boolean): void;
    joinRoom(roomId: string): void;
  };
}

/** Cancel pending entry on route cleanup, without leaving an already joined room. */
export function enterRoomWhenLoaded(roomId: string, load: () => Promise<unknown>): () => void {
  let stopped = false;
  void load().then((module) => {
    if (stopped) return;
    const sync = (module as RoomEntryModule).sharedSync?.();
    if (!sync) return;
    sync.setPresent(true);
    sync.joinRoom(roomId);
  }).catch(() => {
    // The route's REST poll can still display the room when loading fails.
  });
  return () => { stopped = true; };
}
